import { gql } from '@apollo/client';

export const GET_CATEGORIES_BY_SITE = gql`
  query contentCategoriesBySite($siteDomain: String!, $reload: Boolean!) {
    contentCategoriesBySite(siteDomain: $siteDomain, reload: $reload) {
      id
      name
      idFromWp
      depth
      description
      status
      children {
        id
        name
        depth
        parent
        idFromWp
        description
        status
      }
    }
  }
`;

export const ADD_CATEGORY = gql`
  mutation createContentCategory(
    $name: String!
    $siteDomain: String!
    $parent: Float
  ) {
    createContentCategory(
      input: { name: $name, siteDomain: $siteDomain, parent: $parent }
    ) {
      id
      name
    }
  }
`;

export const TRANSLATE_CATEGORIES = gql`
  mutation translateCategories($siteDomain: String!, $categories: [String!]!) {
    translateCategories(siteDomain: $siteDomain, categories: $categories)
  }
`;

export const TRANSLATE_CATEGORIES_DESCRIPTION = gql`
  mutation translateCategoryDescription($siteDomain: String!) {
    translateCategoryDescription(siteDomain: $siteDomain)
  }
`;

export const TRY_AGAIN_TRANSLATE_CATEGORIES = gql`
  mutation tryAgainTranslateCategories($siteDomain: String!, $status: Float!) {
    tryAgainTranslateCategories(siteDomain: $siteDomain, status: $status)
  }
`;
